import './index.scss'

import React from 'react'
import T from 'prop-types'
import { get, findIndex } from 'lodash'
import BEMHelper from 'react-bem-helper'
import Icon from 'components/Icon'

const bem = new BEMHelper('indicators')

export default function Indicators({ steps, step, changeStep, form }) {
  const activeIndex = findIndex(steps, { slug: step })
  const previousSlug = get(steps, `${[activeIndex - 1]}.slug`, null)
  const nextStep = get(steps, `${[activeIndex + 1]}`, null)
  const currentStep = get(steps, `${[activeIndex]}`, null)
  const { error: nextStepError } = nextStep?.validator(form)?.validate(form) || {}
  const { error: currentStepError } =
    currentStep?.validator(form)?.validate(form) || {}

  const handleBack = () => {
    if (previousSlug) {
      changeStep(previousSlug, true)()
    }
  }

  const handleNext = () => {
    if (nextStep?.slug) {
      changeStep(nextStep?.slug)()
    }
  }

  return (
    <nav {...bem('')}>
      <button
        type="button"
        {...bem('button', 'back')}
        onClick={handleBack}
        disabled={!previousSlug}
      >
        <Icon icon="chevron" direction="left" />
      </button>
      <button
        type="button"
        {...bem('button', 'forwards')}
        disabled={!!nextStepError || !nextStep || !!currentStepError}
        onClick={handleNext}
      >
        <Icon icon="chevron" />
      </button>

      <span {...bem('count')}>
        {activeIndex + 1} av {steps.length}
      </span>
    </nav>
  )
}

Indicators.propTypes = {
  steps: T.array.isRequired,
  step: T.string,
  changeStep: T.func.isRequired,
  form: T.object,
}
